export default __webpack_public_path__ + "static/pic08-12d5ddf400e6c7c614e715b19d14d1b5.jpg";